import React from 'react';

const Dashboard = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Agent Dashboard</h1>
      <p className="text-gray-600">Dashboard content - to be implemented</p>
    </div>
  );
};

export default Dashboard;

